module.exports = __webpack_public_path__ + "img/mission-impossible-6-logo.655e51a4.png";